module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/bangdan_icon_more.b6dd6.png";